module.exports = __webpack_public_path__ + "img/1579688209.35e204d6.jpg";